// @flow
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Layout,
  Row,
  Col,
  Select,
  Input,
} from 'antd';
import { SpButton, SpText } from '../DesignKit';
import {
  withRouter,
} from 'react-router-dom';
import styled from 'styled-components';
import type { ContextRouter } from 'react-router-dom';

import {
  notificationActions,
  cartActions,
} from '../../store/actions';

import {
  axiosNoAuthInstance,
  axiosAuthInstance,
  API_END_POINTS,
} from '../../api';
import Cart from '../../assets/imgs/cart.svg';
import User from '../../assets/user.svg';
import UserMenuHide from '../../assets/userMenuHide.svg';
import UserMenuShow from '../../assets/userMenuShow.svg';

const { Option } = Select;
const { Search } = Input;

// $FlowFixMe
const Header = styled(Layout.Header)({
  paddingLeft: '24px',
  paddingRight: '24px',
  height: '70px',
});

type Props = ContextRouter & {
  getCartVisible: Function,
  itemsInfos: Array<Objects>,
  isMobileView: Boolean,
  getSearchItems: Function,
  searchItem: Array<Object>,
  setSearchItems: Function,
  setSelectedAccount: Function,
};

const AppHeader = (props: Props) => {
  const { setSearchItems, searchItem, getSearchItems, shopInfo, getCartVisible, itemsInfos, isMobileView, setSelectedAccount } = props;
  const [searchValue, setSearchValue] = useState('');
  const [bannerImage, setBannerImage] = useState('');
  const [accntName, setAccntName] = useState('');
  const [bannerText, setBannerText] = useState('');

  const getAccountDetails = async () => {
    try {
      const { data: { entity } } = await axiosAuthInstance.get(`${API_END_POINTS.GET_ACCOUNT}/account-441e2ce3c0394b3e922fd1914107fd12`);
      localStorage.setItem('shopGid', entity.gid);
      localStorage.setItem('banner', entity.banner ? entity.banner : entity.largeLogo);
      localStorage.setItem('accountName', entity.name);
      localStorage.setItem('timeZone', entity && entity.timezone);
      setBannerText(entity && entity.bannerText ? entity.bannerText : '');
      setSelectedAccount(entity);
      setAccntName(entity.name);
      setBannerImage(entity.banner ? entity.banner : entity.largeLogo);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getAccountDetails();
  }, []);

  const selectedShop = localStorage.getItem('selectedShop');

  useEffect(() => {
    setSearchValue('');
  }, [selectedShop]);

  const searchItems = async (searchTerm) => {
    setSearchValue(searchTerm);
    if (searchTerm) {
      setSearchItems(true);
      try {
        const { data: { entity } } = await axiosAuthInstance.get(`${API_END_POINTS.GET_ITEMS_DETAILS}/${selectedShop}?name.LIKE=${searchTerm}`);
        getSearchItems(entity);
      } catch (e) {
        console.error(e);
      }
    } else {
      getSearchItems([]);
      setSearchItems(false);
    }
    
  };
  return (
    <>
      <Header className="HEADER" style={{ height: 'auto' }}>
        {
          isMobileView ? (
            <Row justify="space-between" align="middle">
              <Col span={24} className="d-flex justify-content-center align-items-center">
                <div className="d-flex align-items-center">
                  <img src={bannerImage} width='200' style={{ margin: '10px 10px 0px 10px' }} />
                </div>
              </Col>
              {
                bannerText ? (
                  <Col span={24} className="d-flex justify-content-center align-items-center mt-2">
                    <div className="d-flex align-items-center">
                      <div className="info" style={{ lineHeight: '22px', marginTop: '10px' }}>
                        <strong style={{ color: '#E3007B' }}>
                          <div dangerouslySetInnerHTML={{ __html: bannerText.replaceAll('<br>', '') }} />
                        </strong>
                      </div>
                    </div>
                  </Col>
                ) : (
                    <Col span={24} className="d-flex justify-content-center align-items-center">
                      <div className="d-flex align-items-center">
                        <SpText style={{ lineHeight: '22px', marginTop: '10px' }} fontSize="16px" color="#E3007B" fontWeight="700">Deliveries in the Bay Area require pre-orders and are fulfilled on a first-come, first-served basis due to limited quantities.
                         <br />We aim to deliver all paid orders within 24 to 72 hours.
                        </SpText>
                      </div>
                    </Col>
                )
              }
              
            </Row>
          ) : (
            <>
            <Row type="flex" justify="space-between" align="middle">
              <Col xs={{ span: isMobileView ? 24 : 8 }} className="d-flex justify-content-start align-items-center">
                &nbsp;
              </Col>
              <Col xs={{ span: isMobileView ? 24 : 8 }} className="d-flex justify-content-center align-items-center">
                <div className="d-flex align-items-center">
                  <img src={bannerImage} width={isMobileView ? '100' : '300'} style={{ margin: '10px 10px 0px 10px' }} />
                  {/* <div className='vertical-row'></div> */}

                  {/* <div className='d-flex align-items-center'
                        style={{
                          fontSize: isMobileView ? '18px' : '24px', marginLeft: '16px', color: '#4E4E4E', fontWeight: '600'
                        }}
                      >
                        {accntName}
                      </div> */}
                </div>
                
              </Col>
              {
                !isMobileView && (
                  <Col xs={{ span: 8 }} className="d-flex justify-content-end align-items-center">
                    <div className="d-flex align-items-center">
                    <div className='d-flex align-items-center'
                    style={{
                      fontSize: '18px', cursor: 'pointer', marginLeft: '16px', color: '#4E4E4E', fontWeight: '600'
                    }}
                  >
                    <Search placeholder="Search store menu" style={{borderRadius:'34px !important'}} value={searchValue} allowClear onChange={(e) => searchItems(e.currentTarget.value)}/>
                  </div>
                      {/* {
                        userInfo && userInfo.reservationCode && (
                          <div className='d-flex align-items-center'
                            style={{
                              fontSize: '18px', cursor: 'pointer', marginLeft: '16px', color: '#4E4E4E', fontWeight: '600'
                            }}
                          >
                            <SpText fontSize="16px">Group Id</SpText>
                            <div style={{ marginLeft: '10px' }}>
                              <SpText style={{ backgroundColor: '#F2F2F2', padding: '5px', borderRadius: '5px' }} fontSize="16px" color="#00378C" fontWeight="700">{userInfo.reservationCode}</SpText>
                            </div>
                          </div>
                        )
                      } */}

                     
                      {/* <div className='vertical-row'></div>
              <div className='d-flex align-items-center'
                  style={{
                    fontSize: '18px', cursor: 'pointer', marginLeft: '16px', color: '#4E4E4E', fontWeight: '600'
                  }}
                >
                  Sign In
                </div> */}
                    </div>
                  </Col>
                )
              }

            </Row>
            
                {bannerText ? (
                  <Row type="flex" justify="space-between" align="middle">
                    <Col span={24} className="d-flex justify-content-center align-items-center">
                      <div className="d-flex align-items-center">
                        <div className="info" style={{ lineHeight: '30px' }}>
                          <span style={{ color: '#E3007B' }}>
                            <div dangerouslySetInnerHTML={{ __html: bannerText.replaceAll('<br>', '') }} />
                          </span>
                        </div>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <>
                    <Row type="flex" justify="space-between" align="middle">
                      <Col span={24} className="d-flex justify-content-center align-items-center">
                        <div className="d-flex align-items-center">
                          <SpText fontSize="16px" color="#E3007B" fontWeight="700">Deliveries in the Bay Area require pre-orders and are fulfilled on a first-come, first-served basis due to limited quantities.</SpText>
                        </div>
                      </Col>
                    </Row>
                    <Row type="flex" justify="space-between" align="middle">
                      <Col span={24} className="d-flex justify-content-center align-items-center">
                        <div className="d-flex align-items-center">
                          <SpText fontSize="16px" color="#E3007B" fontWeight="700">We aim to deliver all paid orders within 24 to 72 hours.</SpText>
                        </div>
                      </Col>
                    </Row>
                  </>
                )
                }
            
            </>
          )
        }
      </Header>
    </>
  );
};

const mapStateToProps = (state) => ({
  itemsInfos: state.cartInfo.itemsInfos,
  isMobileView: state.cartInfo.isMobileView,
  shopInfo: state.cartInfo.shopInfo,
  searchItem: state.cartInfo.searchItems,
});

const mapDispatchToProps = (dispatch) => ({
  setNotification: ({ type, payload }) => dispatch(notificationActions.setNotification({
    type,
    payload,
  })),
  getCartVisible: param => dispatch(cartActions.getCartVisible({
    payload: param,
  })),
  getSearchItems: param => dispatch(cartActions.getSearchItems({
    payload: param,
  })),
  setSearchItems: param => dispatch(cartActions.setSearchItems({
    payload: param,
  })),
  setSelectedAccount: param => dispatch(cartActions.setSelectedAccount({
    payload: param,
  })),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(AppHeader),
);
